module.exports = __webpack_public_path__ + "img/Icon_comentarios_hover.1eef589f.svg";